export const SET_NOTIFICATION_MESSAGE = "SET_NOTIFICATION_MESSAGE";